import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import {
  siteKey,
  orgId,
  siteId,
  sectionId,
  html,
  style,
  script,
  types,
  values,
  frame,
  tags,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  {
    id: "/Public/Section",
    type: "object",
    properties: {
      siteKey,
      orgId,
      siteId,
      sectionId,
      html,
      style,
      script,
      types,
      values,
      frame,
      tags,
      createdAt,
      updatedAt,
    },
  },
  {
    // Deliberately narrow, matching the project this came from: you name a
    // section and tag it, then fill it in on the edit screen. Asking for markup
    // in a create dialog is how you get a form nobody finishes.
    id: "/Public/Section/Create",
    type: "object",
    properties: {
      sectionId,
      tags,
    },
    // Mirrors SectionInputCreate's non-null fields exactly. An empty `required`
    // array is what left assertValid unable to reject anything in the project
    // this shape came from (A9 in docs/datum-api.md).
    required: ["sectionId"],
  },
  {
    id: "/Public/Section/Update",
    type: "object",
    properties: {
      html,
      style,
      script,
      types,
      values,
      frame,
      tags,
    },
    // `html` is `String!` on SectionInputUpdate, so this cannot reject anything
    // GraphQL would have accepted — it only stops the model layer being
    // reachable with less than the contract promises.
    required: ["html"],
  },
];
